import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useResize } from '../../utils';
import styles from './Card.module.scss';
const overlapThreshold = 24;
const imageMargin = 16;
export const Card = ({ icon, title, description, variant = 'default', headerContent = null, titleIsLink = false, borderRadius = false, }) => {
    const headerContentRef = useRef(null);
    const titleRef = useRef(null);
    const cardRef = useRef(null);
    const imageRef = useRef(null);
    const cardSize = useResize(cardRef);
    const [paddingTop, setPaddingTop] = useState(24);
    useEffect(() => {
        if (headerContentRef.current && titleRef.current && imageRef.current) {
            const totalSize = imageRef.current.clientWidth +
                (variant === 'default' ? titleRef.current.clientWidth + imageMargin : 0) +
                (variant === 'default' && titleIsLink ? 24 : 0) +
                overlapThreshold +
                headerContentRef.current.clientWidth;
            const isOverlapping = cardSize.width < totalSize;
            setPaddingTop((isOverlapping ? headerContentRef.current.clientHeight : 0) + 24);
        }
    }, [cardSize, variant, titleIsLink]);
    return (<div ref={cardRef} className={clsx(styles.card, styles[variant], borderRadius && styles.withBorderRadius)} style={{ paddingTop }}>
      <div ref={imageRef} className={styles.cardImage}>
        {typeof icon === 'string' ? <img src={icon} alt={title}/> : icon}
      </div>
      <div className={styles.cardContent}>
        {headerContent && (<div ref={headerContentRef} className={styles.headerContent}>
            {headerContent}
          </div>)}
        <h3 ref={titleRef} className={clsx('owners-body', titleIsLink && styles.linkTitle)}>
          {title}
        </h3>
        <p className='owners-secondary-text'>{description}</p>
      </div>
    </div>);
};
